import styled from '@emotion/styled';
import { Button, Drawer, Input, Table } from 'antd';
import { useEffect, useState } from 'react';
import { FaPlus } from 'react-icons/fa';
import { MdClose } from 'react-icons/md';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ConnectedUserEntity } from '../../../../entities/ConnectedUserEntity';
import { PartenaireEntity } from '../../../../entities/partenaire.entity';
import { ROUTES } from '../../../../routes';
import { PRIMARY, YELLOW } from '../../../../shared/colors';
import { Layout } from '../../../shared/Layout';
import { PartenaireForm } from '../components/PartenaireForm';
import { getCustomAgences, getCustomPartenaires } from '../network';

const Container = styled.div`
  height: calc(100vh - 30px);
  display: flex;
  background-color: #1c2025;
  color: white;

  .bread-crum span {
    color: white;
  }

  td.ant-table-column-sort {
    background-color: transparent !important;
  }

  th {
    background-color: ${PRIMARY} !important;
    color: white !important;
    font-weight: bold;
  }

  .odd-row {
    background-color: #757575;
    color: white;
  }

  .even-row {
    background-color: #acacac;
    color: white;
  }

  .odd-row,
  .even-row {
    &:hover > td {
      background-color: ${YELLOW} !important;
      cursor: pointer;
      color: black; /* plus lisible */
    }
  }

  .content {
    padding: 50px;
    width: 100%;
    background-color: #1c2025;
    color: white;
  }
`;

export const PartnerPage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [showDrawer, setShowDrawer] = useState(false);
  const [partners, setPartners] = useState<PartenaireEntity[]>([]);
  const [filterPartners, setFilterPartners] = useState<PartenaireEntity[]>([]);
  const history = useHistory();
  const connectedUser: ConnectedUserEntity = useSelector(
    (state: any) => state.userReducer,
  ).user;

  useEffect(() => {
    getCustomPartenaires(connectedUser.id).then(({ data: partners }) => {
      getCustomAgences(connectedUser.id).then(({ data: agences }) => {
        partners.map((item: PartenaireEntity) => {
          item.agences = [];
          for (let age of agences) {
            if (item.url === age.partenaire) {
              item.agences.push(age);
            }
          }
          return item;
        });
        setPartners(partners);
        setFilterPartners(partners);
        setIsLoading(false);
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout>
      <Container>
        <div className='content'>
          <div style={{ marginTop: 0 }}>
            <h2 style={{ color: 'white' }}>Liste des partenaires</h2>

            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginBottom: 5,
              }}
            >
              <Input
                placeholder='Search...'
                style={{ width: 250 }}
                onChange={(e) => {
                  setFilterPartners(
                    partners.filter(
                      (age) =>
                        age.nom
                          .toLowerCase()
                          .includes(e.target.value.toLowerCase()) ||
                        age.localisation
                          .toLowerCase()
                          .includes(e.target.value.toLowerCase()),
                    ),
                  );
                }}
              />

              <Button
                icon={<FaPlus style={{ marginBottom: -2, marginRight: 5 }} />}
                className='butt'
                style={{ borderRadius: 5 }}
                onClick={() => setShowDrawer(true)}
              >
                Nouveau partenaire
              </Button>
            </div>

            <Table
              columns={COLUMNS}
              dataSource={filterPartners}
              rowClassName={(row, index) =>
                index % 2 === 0 ? 'even-row' : 'odd-row'
              }
              rowKey='id'
              size='small'
              loading={isLoading}
              style={{ zoom: 0.9 }}
              pagination={false}
              onRow={(row, rowIndex) => {
                return {
                  onClick: (event) => {
                    history.push(ROUTES.PANEL.ADMIN.AGENCE, {
                      partner: row,
                    });
                  }, // click row
                  onDoubleClick: (event) => {}, // double click row
                  onContextMenu: (event) => {}, // right button click row
                  onMouseEnter: (event) => {}, // mouse enter row
                  onMouseLeave: (event) => {}, // mouse leave row
                };
              }}
            />
          </div>
        </div>
        <Drawer
          title='Ajouter un partenaire'
          placement='right'
          width={400}
          onClose={() => setShowDrawer(false)}
          open={showDrawer}
          closeIcon={<MdClose size={20} />}
        >
          <PartenaireForm
            setShowDrawer={setShowDrawer}
            getNewPartenaire={(part) => {
              setPartners([...partners, part]);
              setFilterPartners([...filterPartners, part]);
            }}
          />
        </Drawer>
      </Container>
    </Layout>
  );
};

const COLUMNS = [
  {
    title: 'Code référent',
    dataIndex: 'code_referent',
    flex: 1,
  },
  {
    title: 'Partenaire',
    dataIndex: 'nom',
    flex: 1,
  },
  {
    title: 'Localisation',
    dataIndex: 'localisation',
    flex: 1,
  },
  {
    title: 'Type',
    dataIndex: 'type',
    flex: 1,
  },
  {
    title: "Nombre d'agence",
    render: (cell: any, row: any) => `${row.agences?.length || 0}`,
    flex: 1,
  },
];
